/**
 * Sigla de 3 letras de cada esteira de trabalho na trilha da placa do Telão.
 *
 * Regra: as 3 primeiras letras do nome, com acento preservado ("Elé"). Exceções escritas aqui
 * quando as 3 letras não identificam a esteira ("Serviço Externo" vira "Ext", não "Ser").
 * Esteira nova sem exceção usa a regra — nunca fica sem sigla.
 */
const EXCECOES: Record<string, string> = {
  SERVICO_EXTERNO: 'Ext',
  PREPARACAO_PINTURA: 'Pre',
};

export function siglaDaEsteira(esteira: { chave: string; nome: string }): string {
  if (EXCECOES[esteira.chave]) return EXCECOES[esteira.chave];
  const letras = (esteira.nome || esteira.chave).trim().replace(/[^A-Za-zÀ-ÿ]/g, '');
  if (!letras) return '?';
  return letras.charAt(0).toUpperCase() + letras.slice(1, 3).toLowerCase();
}
